export type ParaScoreRubricItem = {
	score: 1 | 2 | 3 | 4;
	label: string;
	description: string;
	/** Hex color, e.g. `#DC6B68`. */
	color: string;
};

export const PARA_SCORE_RUBRIC: readonly ParaScoreRubricItem[] = [
	{
		score: 1,
		label: 'Beginning',
		description: 'Just starting to develop the skill. Requires significant guidance and practice.',
		color: '#DC6B68',
	},
	{
		score: 2,
		label: 'Progressing',
		description: 'Partial understanding with some errors or gaps. Needs targeted support and practice.',
		color: '#D4943A',
	},
	{
		score: 3,
		label: 'Proficient',
		description: 'Consistent application of the skill. Ready for new learning with continued review.',
		color: '#5B8DB8',
	},
	{
		score: 4,
		label: 'Mastery',
		description: 'Deep understanding, all elements correct. Ready to move on to new learning.',
		color: '#4A9B6F',
	},
] as const;

